import React, { useEffect, useState } from "react";
import UserDropdown from "./UserDropdown";
import { useAuth } from "@wantable/Shared/Hooks";
import { isDesktop } from "react-device-detect";
import ChevronDown from "@wantable/Shared/src/components/Icons/ChevronDown";
import useDropdownVisible from "../../hooks/useDropdownVisible";

const IMAGES_BASE_URL =
  "https://cl.wantable.com/image/upload/ar_1:1,c_crop,g_center/c_scale,w_800/c_crop,g_center,h_800,w_800/f_auto/fl_keep_iptc/";

interface IUserProps {
  onLogout: () => void;
  isLoggedIn: boolean;
  isMobile: boolean;
  className: string;
}

const User = ({ isLoggedIn, isMobile, className, onLogout }: IUserProps) => {
  const { ref, isDropdownVisible, setIsDropdownVisible } = useDropdownVisible(false);
  const [userData, setUserData] = useState<any>(null);
  const { getUserData, logout } = useAuth();

  const getUser = async () => {
    const user = await getUserData();
    setUserData(user);
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    getUser();
  }, [isLoggedIn]);

  if (!userData) return null;

  const getInitials = () => {
    if (!userData) return "";

    return `${userData?.first_name.split("")[0]}${userData?.last_name.split("")[0]}`;
  };

  return (
    <div
      ref={ref}
      role="button"
      onClick={(event) => {
        event.stopPropagation();
        setIsDropdownVisible((prevState) => !prevState)
      }}
      className="user-icon relative flex justify-center items-center"
      aria-expanded={isDropdownVisible}
    >
      <a
        className={`${className} flex items-center justify-center rounded-full ${
          userData.avatar_public_id ? "" : "bg-core-pink"
        } ${isDesktop ? "text-[12px]" : "text-desktop-body"} text-core-red`}
      >
        {userData.avatar_public_id ? (
          <>
          <img
            src={`${IMAGES_BASE_URL}${userData.avatar_public_id}`}
            className="w-full h-full object-cover rounded-full"
            alt="user avatar"
          />
          </>
        ) : (
          getInitials()
        )}
      </a>
      {isDesktop && !isMobile ?
        <>
          <span className="ml-6">Hi, {userData?.first_name}!
          </span>
          <span>
            <ChevronDown />
          </span>
        </>
        :
        null
      }

      {isDropdownVisible &&
        <UserDropdown
          onLogout={() => {
            logout();
            onLogout();
          }}
        />
      }
    </div>
  );
};

export default User;
